<template>
  <ui-alert v-if="isCancelled" variant="destructive" class="max-w-sm">
    <circle-x-icon />
    <ui-alert-description>
      {{ tr('The subscription has been cancelled.') }}
    </ui-alert-description>
  </ui-alert>
  <ui-button
    v-else-if="hasPaidPackage"
    variant="ghost"
    class="self-start text-destructive hover:text-destructive"
    @click="() => openModal()"
  >
    {{ tr('Cancel subscription') }}
  </ui-button>
</template>

<script>
import { CircleX } from '@lucide/vue';

import CancelSubscriptionModal from '@/ui/components/CancelSubscriptionModal.vue';

export default {
  name: 'CancelSubscriptionModalButton',
  components: {
    CircleXIcon: CircleX,
  },
  computed: {
    hasPaidPackage() {
      return this.$root.currentCompany.paid_subscription !== null;
    },
    isCancelled() {
      return !this.hasPaidPackage
        && this.$root.currentCompany.current_subscription
        && !this.$root.currentCompany.current_subscription.package.is_free_trial;
    },
  },
  methods: {
    openModal() {
      this.$fullscreenModal.open(
        this,
        CancelSubscriptionModal,
        {},
      );
    },
  },
};
</script>
